import React from 'react';
import Draggable from 'react-draggable';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import type { DialogProps, PaperProps } from '@mui/material';
import Paper from '@mui/material/Paper';

function PaperComponent(props: PaperProps) {
  return (
    <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

type Props = Omit<DialogProps, 'PaperComponent'> & {
  title: React.ReactNode;
  actions?: React.ReactNode;
};

const DraggableDialog: React.FC<Props> = ({ title, actions, children, ...rest }) => {
  return (
    <Dialog {...rest} PaperComponent={PaperComponent}>
      <DialogTitle id="draggable-dialog-title">{title}</DialogTitle>
      <DialogContent dividers>{children}</DialogContent>
      {actions && <DialogActions>{actions}</DialogActions>}
    </Dialog>
  );
};

export default DraggableDialog;